import { render } from "./app-form-bank.vue?vue&type=template&id=4ccaaa99"
import script from "./app-form-bank.vue?vue&type=script&lang=js"
export * from "./app-form-bank.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-bank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ccaaa99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ccaaa99', __exports__)) {
    console.log('reload')
    api.reload('4ccaaa99', __exports__)
  }
  
  module.hot.accept("./app-form-bank.vue?vue&type=template&id=4ccaaa99", () => {
    console.log('re-render')
    api.rerender('4ccaaa99', render)
  })

}


export default __exports__